import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import {createPinia} from "pinia";
import {createHead} from '@unhead/vue/client'
import FloatingVue from 'floating-vue'

import '@/assets/main.css';
import '@/assets/styles/text-editor.css';

// import 'ckeditor5/ckeditor5.css';
// import 'ckeditor5-premium-features/ckeditor5-premium-features.css';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowUpRightFromSquare,
    faBell,
    faBook,
    faCaretDown,
    faCaretUp,
    faCheck,
    faChevronDown,
    faChevronUp,
    faCircle,
    faCirclePlus,
    faCircleXmark,
    faDownload,
    faGears,
    faList,
    faMagnifyingGlass,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMinus,
    faPaperPlane,
    faPenToSquare,
    faPlus,
    faPowerOff,
    faSeedling,
    faSpinner,
    faSquareCheck,
    faTable,
    faTrashCan,
    faTriangleExclamation,
    faUpload,
    faUpRightFromSquare,
    faUser,
    faUsers,
    faXmark
} from '@fortawesome/free-solid-svg-icons'
import {faEnvelope, faFloppyDisk, faImage} from '@fortawesome/free-regular-svg-icons'


library.add(faSpinner, faPlus, faArrowDown, faArrowUp, faArrowLeft, faArrowRight, faArrowUpRightFromSquare, faDownload, faChevronDown, faChevronUp, faUsers,
    faFloppyDisk, faTrashCan, faXmark, faPenToSquare, faPowerOff, faSeedling, faUser, faGears, faBook, faCheck, faTriangleExclamation, faCircle, faCirclePlus,
    faCircleXmark, faMagnifyingGlass, faList, faTable, faUpRightFromSquare, faSquareCheck, faBell, faUpload, faMagnifyingGlassMinus,
    faMagnifyingGlassPlus, faPaperPlane, faCaretUp, faCaretDown, faMinus, faEnvelope, faImage)


const pinia = createPinia();
const head = createHead();

createApp(App)
    .use(pinia)
    .use(router)
    .use(head)
    .use(FloatingVue)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
